import React from "react";
import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/lib/css/styles.css"
import objectPath from "object-path";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import cloneDeep from "clone-deep";
import Button from "@material-ui/core/Button";

import Dropzone from "../../Components/Dropzone";
import {
  InputGroup,
  PanelSection,
  PanelContent,
  PanelDescription,
  PrimaryBtn,
  ContainerButtonSubmit,
} from "../../Theme";
import { Container, RestaurantImageContainer, Form } from "./styles";
import { updateAddress, updateTemplate } from "../../Store/Modules/Store/Actions";
import { api } from "../../Services/Api";
import TextField from "@material-ui/core/TextField";

export default function ConfigEstablishment() {
  const dispatch = useDispatch();
  const { isLoading, ...store } = useSelector((state) => state.store);
  const [establishmentConfig, setEstablishmentConfig] = React.useState();
  const [establishmentAddress, setEstablishmentAddress] = React.useState(
    store.address
  );
  const [color, setColor] = useColor("hex", store.template?.primaryColor || "#121212");
  const [template, setTemplate] = React.useState(store.template)
  const [savingImage, setSavingImage] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState();
  const [selectedCoverFile, setSelectedCoverFile] = React.useState();
  const [loading, setLoading] = React.useState(0);

  React.useEffect(() => {
    api
      .get(`establishment/config`)
      .then(({ data }) => {
        setEstablishmentConfig(data);
      })
      .catch((err) => toast.error("Erro ao buscar configurações!"));
  }, []);

  function handleInputChange(event) {
    const { value, name } = event.target;
    const updatedstore = { ...establishmentConfig };
    objectPath.set(updatedstore, name, value);
    setEstablishmentConfig(updatedstore);
  }

  React.useEffect(() => {
    if (selectedFile) {
      const data = new FormData();
      data.append("logo", selectedFile, `logo.png`);
      setSavingImage(true);
      api
        .put(`establishment/config/logo`, data)
        .catch((err) => toast.error("Erro ao salvar imagem"))
        .finally(() => setSavingImage(false));
    }
  }, [selectedFile]);

  React.useEffect(() => {
    if (selectedCoverFile) {
      const data = new FormData();
      data.append("coverImage", selectedCoverFile, `coverImage.png`);
      setSavingImage(true);
      api
        .put(`establishment/config/cover-image`, data)
        .catch((err) => toast.error("Erro ao salvar imagem"))
        .finally(() => setSavingImage(false));
    }
  }, [selectedCoverFile]);

  function handleInputChange(event) {
    const { value, name } = event.target;
    const updatedstore = { ...establishmentConfig };
    objectPath.set(updatedstore, name, value);
    setEstablishmentConfig(updatedstore);
  }

  function handleSubmit(btn) {
    setLoading(btn);
    dispatch({ type: "SET_LOADING" });
    dispatch({
      type: "SAVE_ESTABLISHMENT_CONFIG",
      config: { name: establishmentConfig.name },
    });
  }

  function handleSubmitNameConfig(event) {
    event.preventDefault();
    handleSubmit(1);
  }

  function handleSaveAddress(event) {
    event.preventDefault();
    dispatch(updateAddress(establishmentAddress));
  }

  function handleSaveTemplate(event) {
    event.preventDefault();
    dispatch(updateTemplate(template));
  }

  React.useEffect(() => {
    if (color) {
      setTemplate((prev) => ({ ...prev, primaryColor: color.hex }))
    }
  }, [color])

  if (!establishmentConfig || !store) return null;

  return (
    <Container>
      <PanelSection>
        <PanelDescription>Nome e imagens</PanelDescription>
        <PanelContent>
          <Form onSubmit={handleSubmitNameConfig}>
            <InputGroup>
              <label htmlFor="store-name"> Nome do Restaurante</label>
              <TextField
                value={establishmentConfig.name}
                onChange={handleInputChange}
                id="store-name"
                type="text"
                name="name"
                required
                variant="outlined"
                size="small"
              />
            </InputGroup>
            <RestaurantImageContainer>
              <div>
                <Dropzone
                  style={{ width: "120px", height: "120px" }}
                  initialUrl={establishmentConfig.logoUrl || ""}
                  fileChange={setSelectedFile}
                  label="Logotipo"
                  className="dropzone-square-md"
                  aspect={1}
                />
                {savingImage && <p>Salvando Imagem...</p>}
              </div>
              <div>
                <Dropzone
                  initialUrl={establishmentConfig.coverUrl || ""}
                  fileChange={setSelectedCoverFile}
                  label="Imagem de capa"
                />
                {savingImage && <p>Salvando Imagem...</p>}
              </div>
            </RestaurantImageContainer>
            <hr />
            <ContainerButtonSubmit>
              <Button variant="contained" color="primary" type="submit">
                Salvar
              </Button>
              {loading === 1 && isLoading && (
                <Spinner type="grow" color="primary" />
              )}
            </ContainerButtonSubmit>
          </Form>
        </PanelContent>
      </PanelSection>
      <PanelSection>
        <PanelDescription>
          Endereço do Estabelecimento <br />{" "}
          <small>Usado como endereço de retirada</small>
        </PanelDescription>
        <PanelContent>
          <Form onSubmit={handleSaveAddress}>
            <InputGroup>
              <label htmlFor="store-public-place">Rua</label>
              <input
                value={establishmentAddress.publicPlace}
                onChange={(ev) =>
                  setEstablishmentAddress({
                    ...establishmentAddress,
                    publicPlace: ev.target.value,
                  })
                }
                id="store-public-place"
                type="text"
                name="address.publicPlace"
              />
            </InputGroup>
            <InputGroup>
              <label htmlFor="store-address-number">Numero</label>
              <input
                value={establishmentAddress.number}
                onChange={(ev) =>
                  setEstablishmentAddress({
                    ...establishmentAddress,
                    number: ev.target.value,
                  })
                }
                id="store-address-number"
                type="text"
                name="address.number"
              />
            </InputGroup>
            <InputGroup>
              <label htmlFor="store-address-complement">Complemento</label>
              <input
                value={establishmentAddress.complement}
                onChange={(ev) =>
                  setEstablishmentAddress({
                    ...establishmentAddress,
                    complement: ev.target.value,
                  })
                }
                id="store-address-complement"
                type="text"
                name="address.complement"
              />
            </InputGroup>
            <InputGroup>
              <label htmlFor="store-address-neighborhood">Bairro</label>
              <input
                value={establishmentAddress.neighborhood}
                onChange={(ev) =>
                  setEstablishmentAddress({
                    ...establishmentAddress,
                    neighborhood: ev.target.value,
                  })
                }
                id="store-address-neighborhood"
                type="text"
                name="address.neighborhood"
              />
            </InputGroup>
            <InputGroup>
              <label htmlFor="store-address-city">Cidade</label>
              <input
                value={establishmentAddress.city}
                onChange={(ev) =>
                  setEstablishmentAddress({
                    ...establishmentAddress,
                    city: ev.target.value,
                  })
                }
                id="store-address-city"
                type="text"
                name="address.city"
              />
            </InputGroup>
            <InputGroup>
              <label htmlFor="store-address-state">Estado</label>
              <input
                value={establishmentAddress.state}
                onChange={(ev) =>
                  setEstablishmentAddress({
                    ...establishmentAddress,
                    state: ev.target.value,
                  })
                }
                id="store-address-state"
                type="text"
                name="address.state"
              />
            </InputGroup>
            <InputGroup>
              <label htmlFor="store-address-CEP">CEP</label>
              <input
                value={establishmentAddress.CEP}
                onChange={(ev) =>
                  setEstablishmentAddress({
                    ...establishmentAddress,
                    CEP: ev.target.value,
                  })
                }
                id="store-address-CEP"
                type="text"
                name="address.CEP"
              />
            </InputGroup>
            <hr />
            <ContainerButtonSubmit>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={
                  !establishmentAddress.CEP ||
                  !establishmentAddress.city ||
                  !establishmentAddress.publicPlace ||
                  !establishmentAddress.number ||
                  !establishmentAddress.state ||
                  !establishmentAddress.neighborhood
                }
              >
                Salvar
              </Button>
            </ContainerButtonSubmit>
          </Form>
        </PanelContent>
      </PanelSection>
      <PanelSection>
        <PanelDescription>
          Template<br />{" "}
          <small>Configure a cor dos botões e a mensagem de boas vindas.</small>
        </PanelDescription>
        <PanelContent>
          <Form onSubmit={handleSaveTemplate}>
            <InputGroup>
              <label htmlFor="message-template">Mensagem de boas vindas</label>
              <input
                value={template?.message}
                onChange={(ev) =>
                  setTemplate({
                    ...template,
                    message: ev.target.value,
                  })
                }
                id="message-template"
                type="text"
                name="template.message"
              />
            </InputGroup>
            <InputGroup>
              <label htmlFor="primaryColor-template">Cor dos botões</label>

              <ColorPicker width={228} height={180} color={color} onChange={setColor} hideHSV hideRGB />
            </InputGroup>

            <hr />
            <ContainerButtonSubmit>
              <Button
                variant="contained"
                color="primary"
                type="submit"
              >
                Salvar
              </Button>
            </ContainerButtonSubmit>
          </Form>
        </PanelContent>
      </PanelSection>
    </Container>
  );
}
